export default "__VITE_ASSET__CNmV3dd6__"